const getters = {
  serviceAnnotationsModified: state => state.serviceAnnotationsModified
}
export default getters